export const mockData = {
    "currentHub": {
        "id": 2,
        "latitude": 35.65710092442471,
        "longitude": 51.16581907304506,
        "name": "هاب تهران"
    },
    "items": [
        {
            "currentStatus": {
                "id": 3,
                "text": "در انتظار ورود به هاب"
            },
            "driverId": 7788,
            "driverMobile": "9937899735",
            "driverName": "دشتی",
            "error": "در حال حاضر امکان تخمین زمانی وجود ندارد",
            "nextStatus": {
                "id": 4,
                "text": "ورود به هاب"
            },
            "numberOfBags": 0,
            "numberOfConsignments": 0,
            "plate": [
                "89",
                "ف",
                "896",
                "77"
            ],
            "sourceHub": {
                "id": 1267,
                "latitude": 35.752032,
                "longitude": 51.449969,
                "name": "مرکز توزیع پاسداران"
            },
            "timeToArriveInNextStatus": 0,
            "tripId": 169532,
            "tripNumber": "Trip140551781511580",
            "vehicleType": {
                "id": 0,
                "text": "وانت"
            }
        },
        {
            "currentStatus": {
                "id": 3,
                "text": "در انتظار ورود به هاب"
            },
            "driverId": 6938,
            "driverMobile": "9127473174",
            "driverName": "محمد تقی سلیمانی",
            "error": "در حال حاضر امکان تخمین زمانی وجود ندارد",
            "nextStatus": {
                "id": 4,
                "text": "ورود به هاب"
            },
            "numberOfBags": 0,
            "numberOfConsignments": 0,
            "plate": [
                "63",
                "ل",
                "832",
                "16"
            ],
            "sourceHub": {
                "id": 1685,
                "latitude": 33.98551488071943,
                "longitude": 51.42992556095124,
                "name": "نماینده مرکزی کاشان"
            },
            "timeToArriveInNextStatus": 0,
            "tripId": 169378,
            "tripNumber": "Trip140551584697274",
            "vehicleType": {id:1}
        },
        {
            "currentStatus": {
                "id": 3,
                "text": "در انتظار ورود به هاب"
            },
            "driverId": 2851,
            "driverMobile": "9160780078",
            "driverName": "مهدی نوری",
            "error": "در حال حاضر امکان تخمین زمانی وجود ندارد",
            "nextStatus": {
                "id": 4,
                "text": "ورود به هاب"
            },
            "numberOfBags": 0,
            "numberOfConsignments": 0,
            "plate": [
                "22",
                "ا",
                "222",
                "22"
            ],
            "sourceHub": {
                "id": 1485,
                "latitude": 35.723567,
                "longitude": 51.364167,
                "name": "مرکز توزیع تهران ویلا"
            },
            "timeToArriveInNextStatus": 0,
            "tripId": 169541,
            "tripNumber": "Trip140551783090099",
            "vehicleType": {id:2}
        },
        {
            "currentStatus": {
                "id": 3,
                "text": "در انتظار ورود به هاب"
            },
            "driverId": 1538,
            "driverMobile": "9195271908",
            "driverName": "کامیار ذکایی",
            "error": "در حال حاضر امکان تخمین زمانی وجود ندارد",
            "nextStatus": {
                "id": 4,
                "text": "ورود به هاب"
            },
            "numberOfBags": 0,
            "numberOfConsignments": 0,
            "plate": [
                "57",
                "س",
                "144",
                "60"
            ],
            "sourceHub": {
                "id": 963,
                "latitude": 35.584571,
                "longitude": 53.402777,
                "name": "هاب سمنان"
            },
            "timeToArriveInNextStatus": 0,
            "tripId": 169550,
            "tripNumber": "Trip140551792263694",
            "vehicleType": {id:3}
        }
    ]
}